import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import { useTranslation } from '@cobliteam/i18n';
import { Typography } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import { useLocation } from 'react-router-dom';

type MaintenancePageProps = {
  title: string;
  path: string;
};

type Maintenance = {
  url: string;
  time: number;
  reason?: string;
};

const MaintenancePage = ({ title }: MaintenancePageProps) => {
  const { t } = useTranslation('common');
  const { pathname } = useLocation();
  const featureFlags = useFeatureFlags();
  let maintenance: Maintenance | undefined;
  const { maintenance: maintenanceFlag } = featureFlags;

  // Check for array of objects
  if (Array.isArray(maintenanceFlag)) {
    maintenance = maintenanceFlag.find((flag) => flag && typeof flag === 'object' && 'url' in flag && flag.url === pathname);
  }

  // Make robust check for single object
  if (maintenanceFlag && typeof maintenanceFlag === 'object' && !Array.isArray(maintenanceFlag) && (maintenanceFlag as { url?: unknown }).url === pathname) {
    maintenance = maintenanceFlag as Maintenance;
  }

  return (
    <div className='flex h-full flex-col items-center justify-center gap-6 text-center'>
      <Icon name='wrench' size='4xl' className='box-content overflow-visible rounded-full bg-warning-2 p-10' />

      <div className='flex flex-col items-center justify-center text-center'>
        <Typography variant='heading-2xl' className='font-bold' as='h1'>
          {t('pages.maintenance.title', { title })}
        </Typography>

        <Typography variant='text-md' className='mt-2 text-gray-10'>
          {t('pages.maintenance.description')}
        </Typography>

        {maintenance?.reason && (
          <Typography variant='text-md' className='mt-4 text-gray-12'>
            Observação: {maintenance.reason}
          </Typography>
        )}
      </div>

      {maintenance?.time && (
        <div className='flex flex-col items-center gap-4'>
          <div className='flex items-center gap-2 text-warning-11'>
            <Icon name='clock' size='md' />
            Previsão de tempo: <Typography variant='text-md'>{(maintenance?.time ?? 0) / 60} minutos</Typography>
          </div>
        </div>
      )}
    </div>
  );
};

export default MaintenancePage;
